<template>
	<div>
		<p>
			<!--Who will be collecting data?-->
			{{ selectRandom(["The data will be collected by ", "The data will be gathered by ", "Data collection will be conducted by "]) }}
			{{
				joinArrayWithAnd(formatSelectMulti($tera.project.TrialWizard.collectors))
			}}.
			<!--How will the data be collected?-->
			{{ selectRandom(["The data will be collected using ", "The data will be gathered using ","Data will be collected via "]) }}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.collections)
				)
			}}.
			<!--Where will the data be stored?-->
			{{ selectRandom(["The data will be stored in ", "All data will be stored in ", "Data storage will be managed in "]) }}
			{{
				joinArrayWithAnd(formatSelectMulti($tera.project.TrialWizard.storage))
			}}.
			<!--TODO: Data Security-->
			<!--Data Quality-->
			{{ selectRandom(["Data quality was enhanced by ", "Data quality was improved through ", "The quality of the data was strengthened by "]) }}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.dataQualityProcess)
				)
			}}.

			{{ selectRandom(["Further details are provided in the ","Additional details can be found in the ", "More comprehensive details are outlined in the "]) }}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.furtherDetails)
				)
			}}.
		</p>
		<p>
			<!--Primary Messure-->
			{{
				selectRandom([
					"The primary outcome analysis comparing the groups using a ",
					"Comparing the groupes, the primary outcome analysis will use a ",
					"Primary outcome analysis comparing the groups using a ",
					"The groups will be compared, with a primary outcome analysis of "
				])
			}}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.primaryMeasure)
				)
			}}.
			<!--Secondary Messure-->
			{{
				selectRandom([
					"Secondary outcome analysis comparing the groups using a ",
					"The groups will be compared, with a secondary outcome analysis of ",
					"The secondary outcomes were compared between groups using a ",
					"Comparing the groupes, the secondary outcome analysis will use a "
				])
			}}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.secondaryMeasure)
				)
			}}.

			<!--How were adverse events analysed (select all that apply)-->
			{{ selectRandom(["Adverse events were assessed by ", "The assessment of adverse events was conducted by ", "Adverse events were monitored and assessed by "]) }}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.adverseEventMeasure)
				)
			}}.
		</p>
		<p>
			<!--Subgroups categorise-->
			{{ selectRandom(["Prespecified subgroups for ", "The comparison of prespecified subgroups for ", "Subgroups identified for "]) }}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.subgroupAnalysis)
				)
			}}
			<!--How will subgroup analyses be performed-->
			{{ selectRandom(["were compared using ", "was performed using ", "were prespecified and compared with "]) }}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.subgroupComparison)
				)
			}}.
			<!--Adjusted analysis-->
			{{
				selectRandom([
					"Adjusted analysis will be performed for the primary outcome by ",
					"For the primary outcome, an adjusted analysis with ",
					"For the primary outcome, we will perform an adjusted analysis by ",
					"Adjusted analysis for the primary outcome will be performed by "
				])
			}}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.subgroupMethod)
				)
			}}.
		</p>
		<p>
			{{ selectRandom(["Efficacy comparisons were performed based on the "]) }}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.efficacyComparisons)
				)
			}}

			<!--What population was the efficacy comparisons performed-->
			{{ selectRandom(["population defined as "]) }}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.efficacyPopulation)
				)
			}}.
			<!--Safety population-->
			{{
				selectRandom([
					"Adverse events are compared using the safety population, defined as ",
					"Using the control group to compare adverse events, is defined as ",
					"Adverse events comparing the safety population, defined as ",
					"Adverse events will be compared with the control group, defined as "
				])
			}}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.safetyPopulation)
				)
			}}.
		</p>
		<p>
			{{ selectRandom(["Missing data was "]) }}
			{{
				joinArrayWithOr(formatSelectMulti($tera.project.TrialWizard.missingData))
			}}.
			{{ selectRandom(["This approach was used because "]) }}
			{{
				$tera.project.TrialWizard.missingDataWhy
					? $tera.project.TrialWizard.missingDataWhy
					: "BLANK"
			}}.
			<!--Sensitivity analyses-->
			{{
				selectRandom([
					"Sensitivity analyses will be performed to assess the effect of ",
					"The effect that will be assessed with a sensitivity analyses are ",
					"We are planning to perform a sensitivity analyses to assess the effect of ",
					"A sensitivity analyses were performed to evaluate the effect of "
				])
			}}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.sensitivityAnalyses)
				)
			}}
			{{ selectRandom(["on the robustness of the results"]) }}
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputDataCollection",
	mixins: [OutputMixin]
};
</script>
